module.exports = __webpack_public_path__ + "img/page_1_2.c308e60a.png";